import {Container} from "unstated";
import {Map} from "immutable";

class MapContainer extends Container {
  constructor(props) {
    super(props);
    // Overwrite the very basic setState to handle immutable data
    // be sure to handle the _listeners call
    // https://github.com/jamiebuilds/unstated/blob/master/src/unstated.js
    this.setState = newState => {
      this.state = this.state.merge(newState);
      this._listeners.forEach(fn => fn());
    };
    this.state = Map({
      center: [],
      defaultCenter: [],
      component: null
    });
  }

  // Replace the entire map at a give key
  set = props => {
    this.setState(this.state.merge({...props}));
  };
}

export const mapContainer = new MapContainer();



// WEBPACK FOOTER //
// ./src/contexts/map.js